module.exports = __webpack_public_path__ + "static/media/img_31.ee377865.JPG";